/*eslint-disable*/

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { office } from '../../constant/imagePath';
import {
  useGetAllNeighborhoodsQuery,
  useGetAllProvincesQuery,
  useGetAllTownsQuery
} from '../../store/apiSlice/apiSlice';
import DropDown from '../DropDown/DropDown';
import MapMain from '../maps/MapMain';
import classes from './LocationComponent.module.css';

export let locationArray = [
  {
    en: ' Rent',
    fa: 'اجاره',
    tr: 'Kiralama',
    ar: 'ايجار',
    ru: 'Аренда',
    de: 'Mieten',
    fr: 'Louer',

    _id: '1'
  }
];

const LocationComponent = ({
  locationState,
  setLocationState,
  direction,
  selectedLanguage,
  showMap = true,
  mapMainClass,
  markerIcon = office
}) => {
  const { t } = useTranslation('dashboardProperties', { lng: selectedLanguage?.value });
  const { data: provinces, isLoading: isGettingProvinces } = useGetAllProvincesQuery();
  const { data: towns, isLoading: isGettingTowns } = useGetAllTownsQuery(
    {
      ref: locationState.province?._id
    },
    { skip: !locationState.province?._id }
  );
  const { data: neighborhoods, isLoading: isGettingNeighborhoods } = useGetAllNeighborhoodsQuery(
    {
      ref: locationState.town?._id
    },
    { skip: !locationState.town?._id }
  );

  return (
    <Row className={classes.row_main}>
      <Col md={12}>
        <h4>{t('locationTrans.location')}</h4>
      </Col>
      <Col md={6}>
        <DropDown
          label={t('locationTrans.provinceLabel')}
          placeholder={t('locationTrans.provincePlaceholder')}
          options={provinces?.data}
          indicatorColor="var(--dashboard-text-gray-clr)"
          variant="dashboard"
          getOptionLabel={(e) => e?.name?.[selectedLanguage?.value]}
          optionValue={'_id'}
          value={locationState.province}
          setValue={(e) => {
            // setLocationState({ ...locationState, province: e });
            setLocationState({
              ...locationState,
              province: e,
              town: null,
              neighbourhood: null
            });
          }}
          disabled={isGettingProvinces}
        />
      </Col>
      <Col md={6}>
        <DropDown
          label={t('locationTrans.town')}
          placeholder={t('locationTrans.townPlaceholder')}
          //   options={eventTypes}
          indicatorColor="var(--dashboard-text-gray-clr)"
          variant="dashboard"
          getOptionLabel={(e) => e?.name?.[selectedLanguage?.value]}
          options={towns?.data}
          optionValue={'_id'}
          value={locationState.town}
          setValue={(e) => {
            // setLocationState({ ...locationState, town: e });
            setLocationState({
              ...locationState,
              town: e,
              neighbourhood: null
            });
          }}
          disabled={isGettingTowns}
        />
      </Col>
      <Col md={6}>
        <DropDown
          label={t('locationTrans.neighbourhoodLabel')}
          placeholder={t('locationTrans.neighbourhoodPlaceholder')}
          //   options={eventTypes}
          indicatorColor="var(--dashboard-text-gray-clr)"
          variant="dashboard"
          options={neighborhoods?.data}
          getOptionLabel={(e) => e?.name?.[selectedLanguage?.value]}
          optionValue={'_id'}
          value={locationState.neighbourhood}
          setValue={(e) => {
            setLocationState({ ...locationState, neighbourhood: e });
          }}
          disabled={isGettingNeighborhoods}
        />
      </Col>

      <Col md={6}>
        <MapMain
          label={t('locationTrans.pinLocationLabel') + '*'}
          placeholder={t('locationTrans.pinLocationPlaceholder')}
          variant="dashboard"
          type="places"
          address={locationState.address}
          className={mapMainClass}
          setAddress={null}
          comboRootClassName={direction === 'rtl' ? classes.comboRootClassName : null}
          //   setAddress={(e) => {
          //     setLocationState({ ...locationState, location: e });
          //   }}
          setCoordinates={(e) => {
            setLocationState({
              ...locationState,
              lat: e?.lat,
              lng: e?.lng,
              address: e?.address
            });
          }}
        />
      </Col>

      {showMap && locationState?.lat && locationState?.lng && (
        <Col md={12}>
          <MapMain
            markerIcon={markerIcon}
            mapClass={classes?.mapClass}
            zoom={18}
            options={{
              mapTypeControl: false,
              zoomControl: true
            }}
            showLandMarks={false}
            location={{ lat: locationState?.lat, lng: locationState?.lng }}
            draggable={true}
            getDraggedAddress={(e) => {
              setLocationState({
                ...locationState,

                lat: e?.lat,
                lng: e?.lng,
                address: e?.address
              });
            }}
          />
        </Col>
      )}
    </Row>
  );
};

export default LocationComponent;
